import React from "react";
import { MapPin, Phone, Mail, Clock, Facebook, Instagram } from "lucide-react";
import LogoImage from "../assets/LogoCircularEmpty.png";

export const Footer = () => {
  return (
    <footer id="footer" className="bg-stone-800 text-stone-200 py-12">
      <div className="container mx-auto px-4 flex flex-col items-center text-left">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 justify-items-start w-full">
          <img
            src={LogoImage}
            alt="Gradino Logo"
            width={200}
            height={50}
            className="mb-4"
          />
          {/* Opening Hours */}
          <div>
            <h3 className="text-xl font-semibold uppercase mb-4 flex items-center b  ">
              <Clock className="mr-2" size={24} strokeWidth={1.5} /> Öppettider
            </h3>
            <ul className="space-y-2">
              <li>Mån - Ons: 16:00 - 21:00</li>
              <li>Fredag: 16:00 - 22:00</li>
              <li>Lordag: 12:00 - 22:00</li>
              <li>Sondag: 12:00 - 21:00</li>
            </ul>
          </div>

          {/* Location */}
          <div>
            <h3 className="text-xl font-semibold mb-4 flex items-center">
              <MapPin className="mr-2" size={24} strokeWidth={1.5} /> Plats
            </h3>
            <p>
              <a
                href="https://goo.gl/maps/example"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline hover:text-stone-400"
              >
                Torkelsgatan 9, 753 29 Uppsala
              </a>
            </p>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Kontakt</h3>
            <p className="flex items-center mb-2">
              <Phone className="mr-2" size={24} strokeWidth={1.5} />
              <a href="tel:018695020" className="hover:underline">
                018-69 50 20
              </a>
            </p>
            <p className="flex items-center">
              <Mail className="mr-2" size={24} strokeWidth={1.5} />
              <a href="mailto:info@gradino.se" className="hover:underline">
                info@gradino.se
              </a>
            </p>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Följ oss</h3>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/profile.php?id=100063577960600"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-stone-400 transition-colors"
              >
                <Facebook size={24} strokeWidth={1.5} />
              </a>
              <a
                href="https://www.instagram.com/il_gradino?igsh=NDRsbWxwd2E3bGF6m"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-stone-400 transition-colors"
              >
                <Instagram size={24} strokeWidth={1.5} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-stone-700 text-center w-full">
          <p>
            &copy; {new Date().getFullYear()} Il Gradino. Alla rättigheter
            förbehållna.
          </p>
        </div>
      </div>
    </footer>
  );
};
